/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, lazy } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import RenderComponent from './RenderComponent';
import { hasValue } from 'globalutils/fmUtils';
import Modal from 'globalcomponents/UI/Modal/Clutch';
import Button from 'globalcomponents/UI/Button/Clutch';
import ErrorIcon from 'globalcomponents/ErrorIcon/Clutch';
import SuccessIcon from 'globalcomponents/SuccessIcon/Clutch';
import { initialValues, schema } from './config';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const CheckoutForm = ({
  apiStatus,
  clearApiStatus,
  states,
  getCompanyInfoApi,
  getFleetManagerInfo,
  addCheckout,
  differentAddress,
  totalBill,
  subFilterOption,
  checkoutDetails,
  callback,
  companyInfo,
}) => {
  const [open, setOpen] = React.useState(false);
  const { i18n } = useTranslation();
  const hasApiStatus = hasValue(apiStatus.status, 'api', 'addCompany');

  useEffect(() => {
    if (companyInfo.checkout.status) {
      openModelSuccess();
    }
  }, [companyInfo.checkout]);

  useEffect(() => {
    if (companyInfo?.checkout?.status === 200) window.onbeforeunload = null;
    else window.onbeforeunload = closeIt;
  }, [companyInfo?.checkout?.status]);

  const closeIt = () => {
    return 'Are you sure you want to leave?';
  };

  const closeModalSuccess = (event) => {
    setOpen(false);
  };

  const openModelSuccess = (e) => {
    setOpen(true);
  };

  const getPayload = (fields) => {
    return {
      ...fields,
      ...(getCompanyInfoApi?.companyId ? { companyId: getCompanyInfoApi?.companyId, userId: getFleetManagerInfo?.userId } : {}),
      state: fields?.state?.value || getCompanyInfoApi?.state,
      shippingOption: 'Standard',
      subscriptionPlan: subFilterOption,
      agree: true,
      ...(subFilterOption === 'Monthly'
        ? {
            totalBillMonthly: totalBill,
            taxesMonthly: checkoutDetails.taxesMonthly,
          }
        : {
            totalBillYearly: totalBill,
            taxesYearly: checkoutDetails.taxesYearly,
          }),
    };
  };

  const handleDiffSubmit = (fields) => {
    addCheckout({
      id: 'addCompany',
      data: {
        recipentName: fields?.recipentName || getCompanyInfoApi?.companyName,
        address: fields?.address || getCompanyInfoApi?.address,
        city: fields?.city || getCompanyInfoApi?.city,
        zipCode: fields?.zipCode || getCompanyInfoApi?.zipCode,
        ...getPayload(fields),
      },
      callback: callback,
    });
  };

  const handleSubmit = (fields) => {
    addCheckout({
      id: 'addCompany',
      data: { ...getPayload(fields) },
    });
  };

  return (
    <div className="shippingForm">
      <div className="formLogin forgotPassword">
        <Form
          type="server"
          direction="column"
          initialValues={initialValues}
          RenderComponent={RenderComponent}
          handleOnSubmit={handleSubmit}
          customProps={{
            hasApiStatus,
            clearApiStatus,
            states,
            differentAddress,
            handleDiffSubmit,
          }}
          validationSchema={schema}
        />
      </div>
      {open && (
        <Modal
          open={open}
          setOpen={setOpen}
          data={{
            content: () => (
              <div className="successpopup">
                <h2> {companyInfo.checkout.status === 200 ? 'Registration Completed' : 'Something Went Wrong!'} </h2>
                {companyInfo.checkout.status !== 200 ? <ErrorIcon /> : <SuccessIcon />}
                <label>
                  {' '}
                  {companyInfo.checkout.status === 200
                    ? `Thank you, your registration with Clutch ELD is successfully completed.
               Click the button below to proceed to payment page.`
                    : 'Please try again later'}{' '}
                </label>
                <div className="deletePopupBtn">
                  <Button
                    type="submit"
                    label={companyInfo.checkout.status === 200 ? i18n.t('Proceed to Pay') : i18n.t('common.ok')}
                    onClick={() => {
                      if (companyInfo.checkout.status === 200) {
                        window.location = companyInfo.checkout.message;
                      }

                      closeModalSuccess();
                    }}
                    className="proceedLogin"
                  />
                </div>
              </div>
            ),
          }}
        />
      )}
    </div>
  );
};

export default CheckoutForm;

CheckoutForm.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  requestForgotPassword: PropTypes.func.isRequired,
  callback: PropTypes.func,
  clearApiStatus: PropTypes.func.isRequired,
};
